import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import { StepBox } from '@/components/layout/step-box';
import { MySvgIcon } from '@/components/ui/svg-icon';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';
import { useFlow } from '@/hooks/use-flow';

export const StepAllDone: React.FC<{ type: 'register' | 'recovery' | 'reset' | 'login' }> = ({ type }) => {
  const { t } = useTranslation();
  const { setFlow } = useFlow();
  const {
    setupPwdDoneNextStep: completionNextStep,
    userName,
    callBack: callbackUrl,
    areaCode,
    email,
    phone,
    authType,
  } = useBizState();

  const mapper = {
    register: {
      title: t('account_registration_success_title'),
      description: t('account_registration_success_description'),
    },
    reset: {
      title: t('password_reset_success_title'),
      description: t('password_reset_success_description'),
    },
    recovery: {
      title: t('password_reset_success_title'),
      description: t('password_reset_success_description'),
    },
    login: {
      title: t('completion_title'),
      description: t('close_window_instruction'),
    },
  };

  const { title, description } = mapper[type];

  const handleClick = () => {
    switch (completionNextStep) {
      case Flow.REGISTER_STEP_OPEN_APP:
        setFlow(Flow.LOGIN_STEP_OPEN_APP);
        break;

      case Flow.REGISTER_STEP_SUCCESS_CALLBACK:
        if (callbackUrl) window.location.href = callbackUrl;
        else setFlow(Flow.EXCEPTION_SOMETHING_WENT_WRONG);
        break;

      case Flow.LOGIN_STEP_AUTHORIZATION:
        setFlow(Flow.LOGIN_STEP_AUTHORIZATION);
        break;

      case Flow.REGISTER_STEP_ENABLE_PASSKEY:
        setFlow(Flow.REGISTER_STEP_ENABLE_PASSKEY);
        break;

      default:
        setFlow(Flow.LOGIN_STEP_INPUT_USERNAME, {
          resetBiz: true,
          state: { userName, email, phone, areaCode, authType },
        });
        break;
    }
  };

  return type !== 'login' ? (
    <StepBox title={title}>
      <Stack
        direction={{
          xs: 'column-reverse',
          sm: 'row',
        }}
        spacing={3}
        alignItems={{
          xs: 'center',
          sm: 'start',
        }}
        justifyContent="space-between"
      >
        <Typography>{description}</Typography>
        <MySvgIcon name="done" width={185 * 0.6} height={194 * 0.6} />
      </Stack>
      <Button fullWidth variant="contained" color="primary" onClick={handleClick}>
        {t('go_to_sign_in')}
      </Button>
    </StepBox>
  ) : (
    <StepBox title={title}>
      <Stack spacing={2}>
        <div className="flex w-full flex-col items-center">
          <MySvgIcon name="done" width="185" height="194" />
        </div>
        <Typography className="text-center">{description}</Typography>
      </Stack>
    </StepBox>
  );
};
